import React from 'react';

export default function WaveAnimation(): JSX.Element {
  return (
    <div className='wave-wrapper'>
      <div className='wave' />
    </div>
  )
}